import { Flex, Icon, Text } from '@chakra-ui/react';
import { SFPlusIcon } from '@assets/icons';

const AddButton = ({ text, onClick, testId }) => {
  return (
    <Flex
      align='center'
      justify='center'
      gap={2}
      p={3}
      border='reskin'
      borderColor='surface.containerHigh'
      borderRadius='lg'
      bg='surface.containerHigh'
      w='full'
      cursor='pointer'
      _hover={{ bg: 'surface.containerHighest' }}
      onClick={onClick}
      color='surface.onSurfaceVariant'
      data-testid={testId}
    >
      <Icon
        as={SFPlusIcon}
        boxSize={5}
      />
      <Text
        size='sm'
        letterSpacing='tight'
      >
        {text}
      </Text>
    </Flex>
  );
};

export default AddButton;
